/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Collapse } from "@blueprintjs/core";
import { useEffect } from "react";
import addCSSClass from "src/libs/layout-app/utils/addCSSClass";
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass";
import { __ } from "src/libs/utilities";
import { CARD_FIELD_TYPE } from "src/modules/pe-landing-module/data/interfaces";
import Card, { ICardProps } from "./Card";

/* Protopia Ecosystem component */
export interface IAccordeonCardProps extends ICardProps  {
    isOpen: boolean;
    setOpen: () => void;
}
const AccordeonCard = (props: IAccordeonCardProps): JSX.Element => { 
    const { data, contentData, isOpen } = props
    const allVisibledFields = contentData.card_fields.filter(field => !field.isHidden) 
    
    useEffect(() => {
        
        addCSSClass(
            `landing-card-${data.id}`,
            `.landing-card-${data.id} { 
                z-index: ${ data.i };
                
            }
            .crd-cntnr-${data.id} {
                ${
                    allVisibledFields.length > 0 &&
                    allVisibledFields[0].type === CARD_FIELD_TYPE.MEDALLION 
                        ?
                        `padding-top: ${100}px;`
                        :
                        ""
                }
                ${
                    allVisibledFields.length > 0 &&
                    allVisibledFields[allVisibledFields.length - 1 ].type === CARD_FIELD_TYPE.MEDALLION 
                        ?
                        `padding-bottom: ${100}px;`
                        :
                        ""
                }
            }`
        );

        return () => {
            removeCSSClass(`landing-card-${data.id}`);
        };
    }, [ isOpen ])

    const onOpen = ()=> { 
        props.setOpen() 
    }

    const getTitle = () => {
        if( !!data.cardTitle ) {
            return data.cardTitle
        }
        const isTitle: number = contentData.card_fields.findIndex( f => f.type === CARD_FIELD_TYPE.TITLE )
        if( isTitle > -1 ) {            
            // console.log( data.title?.data , isTitle)            
            return data.title?.data
        }
        return __("Card") + " " + data.id
    }   
    
    return <div 
        className={`pe-accordeon-card-container landing-card-${data.id}`} 
        style={{ ...contentData.cardStyle, ...data.cardStyle, }}
    >
        <div     
            onClick={() => onOpen( )}  
            className=" accordeon-btn" 
            style={{ backgroundColor: data.cardColor }}
        >
            <div className="w-100 d-flex justify-content-between align-items-center pl-4 pr-1 py-1 pointer" style={{ backgroundColor: "var(--force-mini-contast-color)" }}>
                <i className={`${data.cardIcon} mr-3`} />
                <div className="w-100 my-title">{ getTitle() } </div>
                <i className={ `cross-icon fas fa-${ contentData.cross_icon || "chevron-right" } ${ isOpen ? "down" : "" }` } style={ contentData.cross_icon_style } />
            </div>
        </div>
        <Collapse isOpen={isOpen} className="w-100">
            <div 
                className={`crd-cntnr crd-cntnr-${data.id}`}
                style={{
                    paddingTop: allVisibledFields.length > 0 &&
                        allVisibledFields[0].type === CARD_FIELD_TYPE.MEDALLION 
                            ? 
                            100 
                            : 
                            0,
                    paddingBottom: allVisibledFields.length > 0 &&
                        allVisibledFields[allVisibledFields.length - 1 ].type === CARD_FIELD_TYPE.MEDALLION 
                            ?
                            100
                            :
                            0
                }}
            >
                 <Card
                    key={ data.id }
                    data={ { ...data, i: props.i } }
                    width={ 100 }
                    contentData={ contentData }
                    section={ props.section }
                />      
            </div>
        </Collapse>
    </div>
}
export default AccordeonCard